import * as React from 'react';

import { Button, Stack, Typography } from '@mui/material';

const NotFound: React.FC = () => {
  return (
    <Stack
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 'auto',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
        404 - Not Found
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        The page you are looking for does not exist.
      </Typography>
      <Button href="/" sx={{ marginTop: '10px' }}>
        Go to Home Page
      </Button>
    </Stack>
  );
};

export default NotFound;
